import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IButtonData, IStickyFooter } from "./index"

export const stickyFooterSlice = createSlice({
    name: "stickyFooter",

    initialState: {
        buttons: [],
        isLoading: false,
    } as IStickyFooter,

    reducers: {
        receiveButtons: (state, action: PayloadAction<IButtonData[]>) => {
            state.buttons = action.payload
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
    },
})

export default stickyFooterSlice.reducer

export const { setIsLoading, receiveButtons } = stickyFooterSlice.actions
